import {http} from 'hiya-common/src/utils/axios'

export async function is_hit_first_recharge(params?: {from?: string}) {
  const res = await http.post('live/misc/is_hit_first_recharge', {
    ...window.store.getState().env.deviceinfo,
    ...params,
  })
  return res.data.data
}
export enum recharge_type_enum {
  正常第三方支付 = 0,
  币商充值 = 1,
}
// [创建订单前的校验信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127566187
export async function info_before_create_order(params: {
  product_id: string
  recharge_type: recharge_type_enum
}) {
  const res = await http.post<
    // 0不需要任何弹窗，不阻断 1仅弹窗提示，不阻断充值  2弹窗提示，且阻断充值
    HiyaRes<{err_msg: string; msg: string; status: 0 | 1 | 2}>
  >('/live/pay/info_before_create_order', {
    ...window.store.getState().env.deviceinfo,
    ...params,
  })
  return res.data.data
}
